import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 24px;
  width: 100%;

  @media (min-width: ${DEVICE.mobileL}) {
    max-width: 500px;
  }
  @media (min-width: ${DEVICE.laptopM}) {
    max-width: 856px;
  }
`;

export const PmsGuestPanelContainer = styled.div`
  margin-bottom: 48px;
  margin-top: 56px;

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
    margin-top: 0;
  }

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 0;
  }
`;
